import styled from 'styled-components';
import { screenSm } from 'constants/styles/breakpoints';
import { ASIDE_DESKTOP_WIDTH, HEADER_HEIGHT } from 'constants/settings';

export const BannerSpacer = styled.div`
  height: 60px;

  ${screenSm} {
    height: 64px;
  }
`;

export const BannerContainer = styled.div`
  position: fixed;
  top: calc(var(--layout-top-bar-height, 0px) + ${HEADER_HEIGHT}px);
  left: 0;
  right: 0;
  z-index: 899;
  background: linear-gradient(90deg, #234c8d 0%, #1c91ce 100%);
  box-shadow: 0px 10px 24px rgba(28, 145, 206, 0.18);

  ${screenSm} {
    left: ${ASIDE_DESKTOP_WIDTH}px;
    width: calc(100vw - ${ASIDE_DESKTOP_WIDTH}px);
  }
`;

export const BannerContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 10px 14px;

  ${screenSm} {
    min-height: 40px;
    padding: 12px 18px;
  }
`;

export const BannerText = styled.p`
  margin: 0;
  color: var(--white);
  font-family: var(--font-family-base);
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;

  ${screenSm} {
    font-size: 14px;
    line-height: 20px;
  }
`;
